<template>
  <base-notification-item-wrapper-parts
    :notification="notification"
    class="base-notification-item-contents-parts"
    @handlerClickLink="$emit('handlerClickLink', notification)"
  >
    <div
      class="base-notification-item-contents-parts__contents"
      :class="{
        'base-notification-item-contents-parts__contents--has-link': notification.link,
      }"
    >
      <header class="base-notification-item-contents-parts__header">
        <notification-type-icon-parts
          class="base-notification-item-contents-parts__type-icon"
          :notificationType="notification.type"
        />

        <comment-post-date-parts
          class="base-notification-item-contents-parts__post-date"
          :postDate="notification.date"
        />

        <h3
          class="base-notification-item-contents-parts__title"
          v-text="notification.title[$i18n.locale]"
        />
      </header>

      <h5
        class="base-notification-item-contents-parts__message"
        v-if="notification.message"
        v-html="notification.message[$i18n.locale]"
      />

      <p
        class="base-notification-item-contents-parts__note"
        v-if="notification.note"
        v-html="notification.note"
      />

      <i v-if="notification.link" class="base-notification-item-contents-parts__link-icon">
        <img
          v-if="isExternalLink(notification.link)"
          :src="require('@/assets/img/icon/icon_external_link_outline.svg')"
          alt=""
        />
        <img v-else :src="require('@/assets/img/icon/icon_chevron_right_24.svg')" alt="" />
      </i>
    </div>

    <slot />
  </base-notification-item-wrapper-parts>
</template>

<script lang="ts">
import { defineComponent, PropType } from '@vue/composition-api'
import useCheckURL from '@/components/hook/useCheckURL'
import { NotificationItemType } from '@/components/NotificationPane/NotificationPane.vue'
import BaseNotificationItemWrapperParts from '@/components/NotificationPane/NotificationPane/parts/BaseNotificationItemWrapperParts.vue'
import CommentPostDateParts from '@/components/RaceVideoPage/RaceVideoHighlightsPane/parts/CommentPostDateParts.vue'
import NotificationTypeIconParts from '@/components/NotificationPane/NotificationPane/parts/NotificationTypeIconParts.vue'

/**
 * Notification 詳細アイテム: ベースパーツ
 */
export default defineComponent({
  name: 'BaseNotificationItemContentsParts',
  components: {
    NotificationTypeIconParts,
    CommentPostDateParts,
    BaseNotificationItemWrapperParts,
  },
  props: {
    notification: {
      type: Object as PropType<NotificationItemType>,
      required: true,
    },
  },
  setup() {
    // 外部リンク判定関数取得
    const { isExternalLink } = useCheckURL()

    return {
      isExternalLink,
    }
  },
})
</script>

<style lang="scss" scoped>
.base-notification-item-contents-parts {
  display: flex;
  flex-direction: column;
  font-family: $fontSignup;

  &__contents {
    position: relative;
    display: flex;
    flex-direction: column;

    &--has-link {
      padding-right: 24px;
    }
  }

  &__header {
    display: flex;
    flex-flow: row wrap;
    align-items: center;
    justify-content: flex-start;
    gap: 10px 8px;
  }

  &__title {
    width: 100%;
    color: $black;
    font-size: 14px;
    font-style: normal;
    font-weight: 700;
    line-height: 1.42857;
    letter-spacing: 0.02em;
  }

  &__message {
    margin-top: 6px;
    font-size: 13px;
    line-height: 1.53846;
    letter-spacing: 0.04em;
    white-space: pre-line;
  }

  &__note {
    margin-top: 6px;
    color: $gray50;
    font-size: 12px;
    line-height: 1.66667;
    letter-spacing: 0.24px;
  }

  &__link-icon {
    display: block;
    position: absolute;
    right: 0;
    top: 50%;
    transform: translate(0, -50%);

    img {
      width: 24px;
      height: 24px;
    }
  }
}
</style>

<style lang="scss">
.base-notification-item-contents-parts {
  .comment-post-date-parts {
    color: rgba(0, 0, 0, 0.7);
    font-size: 13px;
    font-weight: 500;
    line-height: 1.53846;
    letter-spacing: 0.04em;
    font-family: $fontFamilyDefault;
  }
}
</style>
